import { render, staticRenderFns } from "./IncidentManagement.vue?vue&type=template&id=23db98b7&scoped=true&"
import script from "./IncidentManagement.vue?vue&type=script&lang=js&"
export * from "./IncidentManagement.vue?vue&type=script&lang=js&"
import style0 from "./IncidentManagement.vue?vue&type=style&index=0&id=23db98b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23db98b7",
  null
  
)

component.options.__file = "IncidentManagement.vue"
export default component.exports